module.exports = __webpack_public_path__ + "static/media/orinocco100.1797c546.jpg";